<style>
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.detail-row {
  display: flex;
  padding: 0 20px;
}
.detail-row .item {
  display: flex;
  flex: 1;
  align-items: center;
}
.detail-row .item .tittle {
  width: 110px;
  text-align: left;
}
.detail-row .item .content {
  width: 500px;
  text-align: left;
}
.detail-row .pdf-container img {
  width: 40px;
  height: 40px;
}
.detail-row .item .pdf-container {
  width: auto;
  text-align: center;
}
</style>
<style >
.contract .el-form-item__content {
  margin-left: 0 !important;
}
.el-tooltip__popper {
  max-width: 50%;
}
</style>
<template>
  <div class="content contract">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="8"
          ><div class="search-area-div">公司名称：</div>
          <el-input size="mini" v-model="page.tenantName" class="ipt-sty" placeholder="请输入公司名称"></el-input
        ></el-col>
        <el-col :span="8"
          ><div class="search-area-div">合同名称：</div>
          <el-input size="mini" v-model="page.contractName" class="ipt-sty" placeholder="请输入合同名称"></el-input
        ></el-col>
        <el-col :span="8">
          <div class="search-area-div">合同时间：</div>
          <el-date-picker
          size="mini"
            class="ipt-sty"
            v-model="timeRange"
            type="daterange"
            align="left"
            unlink-panels
            range-separator="-"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd"
            :clearable="false"
          >
          </el-date-picker>
        </el-col>
      </el-row>
      <div style="padding: 20px 20px 0 0; text-align: right" class="search-btn-box">
        <el-button size="mini" type="info" @click="search">搜索</el-button>
        <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
      </div>
    </div>


    <div class="back-color-fff   content-main-box"  :style="'height:' + contentMainHeight + 'px;'">
      <div class="button-area">
         <el-button icon="el-icon-plus" size="mini" type="info" @click="addContract">新建合同</el-button>
       </div>
      <el-table :height="height" :data="tableData" stripe border style="width: 100%" v-loading="tableLoading">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="contractName"
          label="合同名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="250"
        >
          <template slot-scope="scope">{{ scope.row.contractName }}</template>
        </el-table-column>

        <el-table-column
          prop="tenantName"
          label="公司名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="250"
        >
          <template slot-scope="scope">{{ scope.row.tenantName }}</template>
        </el-table-column>

        <el-table-column
          prop="serviceName"
          label="服务商名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="250"
        >
          <template slot-scope="scope">{{ scope.row.serviceName }}</template>
        </el-table-column>
        <el-table-column
          prop="payMoney"
          label="收费方式"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="150"
        >
          <template slot-scope="scope">{{ scope.row.tollType }}</template>
        </el-table-column>
        <el-table-column prop="startTime" label="合同开始时间" header-align="center" align="center" width="150">
          <template slot-scope="scope">{{ scope.row.startTime | getDate }}</template>
        </el-table-column>
        <el-table-column prop="endTime" label="合同结束时间" header-align="center" align="center" width="150">
          <template slot-scope="scope">{{ scope.row.endTime | getDate }}</template>
        </el-table-column>
        <el-table-column prop="contractYear" label="合同期限" header-align="center" align="center" width="150">
          <template slot-scope="scope">{{ scope.row.contractYear }}</template>
        </el-table-column>
        <el-table-column prop="contractYear" label="是否续约" header-align="center" align="center" width="150">
          <template slot-scope="scope">{{ scope.row.isContinue == 1 ? '是' : '否' }}</template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" header-align="center" align="center" width="150">
          <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template>
        </el-table-column>
        <el-table-column prop="contractYear" label="创建人" header-align="center" align="center" width="150">
          <template slot-scope="scope">{{ scope.row.createUserName }}</template>
        </el-table-column>
        <el-table-column prop="bank" width="200" label="操作" fixed="right" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="seeContract(scope.row)">查看合同 ｜</a>
            <a class="txt-color" @click="editContract(scope.row)">编辑 ｜</a>
            <a class="txt-color" style="color: red !important" @click="delContract(scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>

    <el-dialog :title="textTitle" :visible.sync="dialogVisible" width="50%">
      <el-form label-width="140px" :label-position="right" class="demo-ruleForm">
        <el-form-item >
          <span slot="label" style="color: red">*</span>
          <span slot="label">合同名称 </span>
          <el-input
            class="fl"
            style="width: 400px"
            type="input"
            :maxlength="200"
            placeholder="最多可输入200个字"
            v-model="contractName"
          >
          </el-input>
        </el-form-item>
        <el-form-item >
          <span slot="label" style="color: red">*</span>
          <span slot="label">"公司名称(甲方) </span>
          <el-select v-model="tenantGuid" placeholder="请选择" class="fl" style="width: 400px">
            <el-option 
              v-for="item in tenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            >
            </el-option>
            
          </el-select>
        </el-form-item>
        <div style="clear: both"></div>
        <el-form-item >
          <span slot="label" style="color: red">*</span>
          <span slot="label">服务商(乙方) </span>
          <el-input
            class="fl"
            style="width: 400px"
            type="input"
            :maxlength="200"
            placeholder="最多可输入200个字"
            v-model="serviceName"
          >
          </el-input>
        </el-form-item>
        <el-form-item >
          <span slot="label" style="color: red">*</span>
          <span slot="label">合同开始时间 </span>
          <el-date-picker
            class="fl"
            style="width: 400px"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            v-model="startTime"
            type="date"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item >
          <span slot="label" style="color: red">*</span>
          <span slot="label">合同结束时间 </span>
          <el-date-picker
            class="fl"
            style="width: 400px"
            value-format="yyyy-MM-dd"
            v-model="endTime"
            format="yyyy-MM-dd"
            type="date"
            placeholder="选择结束时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item >
              <span slot="label" style="color: red">*</span>
          <span slot="label">合同期限 </span>
          <el-select class="fl" style="width: 400px" v-model="contractYear" placeholder="请选择">
            <el-option
              v-for="item in contractYearList"
              :key="item.parameterValue"
              :label="item.label"
              :value="item.parameterValue"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否续约:" style="display: flex; align-items: center">
           <span slot="label" style="color: red">*</span>
          <span slot="label">是否续约 </span>
          <el-radio-group v-model="isContinue" style="text-align: left">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
             <span slot="label" style="color: red">*</span>
          <span slot="label">核心服务内容 </span>
          <el-input
            class="fl"
            style="width: 400px"
            type="textarea"
            :rows="5"
            :maxlength="200"
            placeholder="最多可输入200个字"
            v-model="serviceContent"
          >
          </el-input>
        </el-form-item>
        <el-form-item >
          <span slot="label" style="color: red">*</span>
          <span slot="label">收费方式 </span>
          <el-input
            class="fl"
            style="width: 400px"
            type="textarea"
            :rows="5"
            :maxlength="200"
            placeholder="最多可输入200个字"
            v-model="tollType"
          >
          </el-input>
        </el-form-item>
        <el-form-item >
          <span slot="label" style="color: red">*</span>
          <span slot="label">上传合同文件 </span>
          <el-upload
            class="upload-demo fl t-left"
            action="#"
            multiple
            :limit="1"
            accept=".pdf,.PDF,.docx,.xlsx,.doc,.xlsm"
            :on-exceed="handleExceed"
            :on-remove="handlePdfRemove"
            :http-request="uploadPdf"
            :file-list="filePdfAttachList"
          >
            <el-button size="medium" type="info">点击上传文件</el-button>
            <div slot="tip" class="el-upload__tip">
              当前支持 word、pdf、excel，请使用 Office 2010 及以上版本，否则可能出现乱码
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="dialogVisible = false">取 消</el-button>
        <el-button
          size="medium"
          type="info"
          v-if="textTitle == '新建合同'"
          @click="addReqVersion"
          v-loading.fullscreen.lock="fullscreenLoading"
          >确 定</el-button
        >
        <el-button
          size="medium"
          type="info"
          v-else
          @click="updateReqVersion"
          v-loading.fullscreen.lock="fullscreenLoading"
          >修 改</el-button
        >
      </span>
    </el-dialog>
    <!-- <el-dialog title="数字化运营委托服务协议" :visible.sync="detailVisible" width="50%">
      <div class="detail-row">
        <div class="item">
          <div class="tittle">公司名称(甲方)：</div>
          <div class="content">{{ detail.tenantName }}</div>
        </div>
      </div>
      <div class="detail-row">
        <div class="item">
          <div class="tittle">服务商(乙方)：</div>
          <div class="content">{{ detail.serviceName }}</div>
        </div>
      </div>
      <div class="detail-row">
        <div class="item">
          <div class="tittle">合同开始时间：</div>
          <div class="content">{{ detail.startTime | getDate }}</div>
        </div>
      </div>
      <div class="detail-row">
        <div class="item">
          <div class="tittle">合同结束时间：</div>
          <div class="content">{{ detail.endTime | getDate }}</div>
        </div>
      </div>
      <div class="detail-row">
        <div class="item">
          <div class="tittle">合同期限：</div>
          <div class="content">{{ detail.contractYear }}</div>
        </div>
      </div>
      <div class="detail-row">
        <div class="item">
          <div class="tittle">收费方式：</div>
          <div class="content">{{ detail.tollType }}</div>
        </div>
      </div>
      <div class="detail-row">
        <div class="item">
          <div class="tittle">核心服务内容：</div>
          <div class="content">{{ detail.serviceContent }}</div>
        </div>
      </div>
      <div class="detail-row">
        <div class="item">
          <div class="tittle">合同文件</div>
          <div class="content pdf-container">
            <img
              src="data:image/png;base64,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"
              alt=""
              srcset=""
            />
            <div>数字化运营委托服务协议.pdf</div>
            <a
              :href="detail.contractFile + '?response-content-type=application/octet-stream'"
              style="text-decoration: underline; cursor: pointer; color: #4fa1a4"
              download="FileName"
              >点击下载</a
            >
          </div>
        </div>
      </div>
      <div class="detail-row" style="display: flex; justify-content: center">
        <el-button style="width: 200px; margin-top: 20px" @click="detailVisible = false">关闭</el-button>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  data() {
    return {
      height: window.innerHeight - 280,
      fullscreenLoading: false,
      textTitle: '新增平台',
      dialogVisible: false,
      // detailVisible: false,
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantName: '',
        contractName: '',
        startTime: '',
        endTime: '',
      },
      timeRange: '',
      contractYearList: [
    
      ],
      isContinue: 1,
      contractYear: '',
      contractName: '',
      tenantName: '',
      tenantGuid: '',
      startTime: '',
      endTime: '',
      tollType: '',
      serviceContent: '',
      serviceName: '',
      guid: '',
      tableLoading: false,
      tableData: [],
      height: window.innerHeight - 400,
      right: 'right',

      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file`,
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      filePdfAttachList: [],
      // detailVisible: false,
      detail: {},
      tenantList: [],
    };
  },
  created() {
    this.getHTQX();
    this.getList();
    this.getTenantList();
  },
  watch: {},
  methods: {
     getTenantList() {
      let self = this;
      let query = {
        isService:true,
        tenantGuid:localStorage.guid
      };
      self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data;
        } else {
          self.$message.error(res.data.msg);
        }
      });
     },
    // downLoadExcel(url) {
    //   window
    //     .fetch(url, {
    //       method: 'get',
    //       responseType: 'blob',
    //       credentials:'include'
    //     })
    //     .then((res) => {
    //       console.log('blob res', res);
    //       return res.blob();
    //     })
    //     .then((blob) => {
    //       console.log('下载 blob', blob);
    //       let bl = new Blob([blob], { type: 'application/pdf' });
    //       //自定义修改 命名规则
    //       let fileName = Date.parse(new Date()) + '.pdf';
    //       var link = document.createElement('a');
    //       link.href = window.URL.createObjectURL(blob);
    //       link.download = fileName; //时间戳命名
    //       link.click();
    //       window.URL.revokeObjectURL(link.href);
    //     });
    // },
    search() {
      let self = this;
      if (self.timeRange && self.timeRange.length != 0) {
        self.page.startTime = self.timeRange[0] + ' ' + '00:00:00';
        self.page.endTime = self.timeRange[1] + ' ' + '23:59:59';
      }
      let req = {
        pageIndex: 1,
        pageSize: 10,
        tenantName: self.page.tenantName,
        contractName: self.page.contractName,
        startTime: self.page.startTime,
        endTime: self.page.endTime,
      };
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/tenant-biz/contract/get-list`, req).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantName: '',
        contractName: '',
        startTime: '',
        endTime: '',
      };
      this.timeRange = '';
      this.getList();
    },
    addContract() {
      this.textTitle = '新建合同';
      this.guid = '';
      this.tenantGuid = '';
      this.tenantName = '';
      this.contractName = '';
      this.serviceName = '';
      this.startTime = '';
      this.endTime = '';
      this.contractYear = '';
      this.serviceContent = '';
      this.tollType = '';
      this.isContinue = '1';
      this.filePdfAttachList = [];

      this.dialogVisible = true;
    },
    editContract(detail) {
      this.textTitle = '修改合同';
      this.guid = detail.guid;
      this.tenantName = detail.tenantName;
      this.tenantGuid = detail.tenantGuid;
      this.contractName = detail.contractName;
      this.serviceName = detail.serviceName;
      this.startTime = detail.startTime.substring(0, 10);
      this.endTime = detail.endTime.substring(0, 10);
      this.contractYear = detail.contractYear;
      this.serviceContent = detail.serviceContent;
      this.tollType = detail.tollType;
      this.isContinue = detail.isContinue + '';
      this.filePdfAttachList = JSON.parse(detail.contractFile)
      this.dialogVisible = true;
    },
    seeContract(detail) {
      // this.detailVisible = true;
      // this.detail = detail;
      this.$router.push({
        path:'/contractDetail',
        query:{
          productGuid:this.$route.query.productGuid,
          contractDetail:JSON.stringify(detail)
        }
      })
    },

    getHTQX() {
      let that = this;
      that.api
        .get(
          `/${serverConfig.msConfigureService}/sysparameter/data/get-detail-grp?tenantGuid=${localStorage.guid}&code=HTQX`,
        )
        .then((resp) => {
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.contractYearList = resp.data.data;
            this.$forceUpdate();
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getList() {
      let self = this;
      if (self.timeRange && self.timeRange.length != 0) {
        self.page.startTime = self.timeRange[0] + ' ' + '00:00:00';
        self.page.endTime = self.timeRange[1] + ' ' + '23:59:59';
      }
      self.tableLoading = true;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/tenant-biz/contract/get-list`, this.page)
        .then((res) => {
          self.tableLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableData = res.data.data.records;
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    delContract(guid) {
      var self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api
            .postJson(`/${serverConfig.msSalesPerformService}/tenant-biz/contract/delete?guid=${guid}`)
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message.success('删除成功');
                self.page.pageIndex = 1;
                self.getList();
              } else {
                self.$message.error(res.data.msg);
              }
            });
        });
    },
    addReqVersion() {
      var self = this;
      if (!this.contractName) {
        self.$message('请输入合同名称');
        return;
      }
      if (!this.tenantGuid) {
        self.$message('请选择公司（甲方）');
        return;
      }
      if (!this.serviceName) {
        self.$message('请输入服务商(乙方)');
        return;
      }
      if (!this.startTime) {
        self.$message('请选择合同开始时间');
        return;
      }
      if (!this.endTime) {
        self.$message('请选择合同结束时间');
        return;
      }
      if (new Date(this.startTime) > new Date(this.endTime)) {
        self.$message('合同结束时间不能早于开始时间');
        return;
      }
      if (!this.contractYear) {
        self.$message('请输入合同期限');
        return;
      }
      if (!this.serviceContent) {
        self.$message('请输入合核心服务内容');
        return;
      }
      if (!this.tollType) {
        self.$message('请输入收费方式');
        return;
      }
      if (this.filePdfAttachList.length == 0) {
        self.$message('请上传合同文件');
        return;
      }
      var contractFile = JSON.stringify(this.filePdfAttachList) ;
      var tenantList = this.tenantList;
      var tenantObj = tenantList.find((item) => item.sendTenantGuid == this.tenantGuid);
      var req = {
        tenantName: tenantObj.sendTenantName,
        contractName: this.contractName,
        serviceName: this.serviceName,
        startTime: this.startTime + ' 00:00:00',
        endTime: this.endTime + ' 23:59:59',
        contractYear: this.contractYear,
        serviceContent: this.serviceContent,
        tollType: this.tollType,
        contractFile: contractFile,
        isContinue: +this.isContinue,
        tenantGuid: this.tenantGuid,
      };

      self.api.postJson(`/${serverConfig.msSalesPerformService}/tenant-biz/contract/edit`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('新增成功');
          self.page.pageIndex = 1;
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    updateReqVersion(isOpen) {
      var self = this;
      if (!this.contractName) {
        self.$message('请输入合同名称');
        return;
      }
      if (!this.tenantName) {
        self.$message('请输入公司名称（甲方）');
        return;
      }
      if (!this.serviceName) {
        self.$message('请输入服务商(乙方)');
        return;
      }
      if (!this.startTime) {
        self.$message('请选择合同开始时间');
        return;
      }
      if (!this.endTime) {
        self.$message('请选择合同结束时间');
        return;
      }
      if (!this.contractYear) {
        self.$message('请输入合同期限');
        return;
      }
      if (!this.serviceContent) {
        self.$message('请输入合核心服务内容');
        return;
      }
      if (!this.tollType) {
        self.$message('请输入收费方式');
        return;
      }
      if (this.filePdfAttachList.length == 0) {
        self.$message('请上传合同文件');
        return;
      }
      var contractFile = JSON.stringify(this.filePdfAttachList) ;
       var tenantList = this.tenantList;
      var tenantObj = tenantList.find((item) => item.sendTenantGuid == this.tenantGuid);
      var req = {
        guid: this.guid,
        tenantName: tenantObj.sendTenantName,
        contractName: this.contractName,
        serviceName: this.serviceName,
        startTime: this.startTime + ' 00:00:00',
        endTime: this.endTime + ' 23:59:59',
        contractYear: this.contractYear,
        serviceContent: this.serviceContent,
        tollType: this.tollType,
        contractFile: contractFile,
        isContinue: +this.isContinue,
        tenantGuid: this.tenantGuid,
      };

      self.api.postJson(`/${serverConfig.msSalesPerformService}/tenant-biz/contract/edit`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('编辑成功');
          self.page.pageIndex = 1;
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },

    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },

    handleExceed(files, filePdfAttachList) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    handlePdfRemove(file) {
      let self = this;
      self.filePdfAttachList.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.filePdfAttachList.splice(ind, 1);
        }
      });
    },
    uploadPdf(file) {
      let self = this;
      console.log(file.file);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: file.file.name,
              url: res.data.data,
            };
            self.filePdfAttachList.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
</style>